import type { EmptyReason } from '@/features/dashboard/api/schemas'
import { ClearCircleIcon } from '@/shared/ui/icons'
import styles from './EmptyCardMessage.module.css'

type EmptyCardMessageProps = {
  reason: EmptyReason
  /** Clears the market filters, which is what un-empties a card. */
  onClear: () => void
  className?: string | undefined
}

/** What a tile, panel or deep-dive card shows when the filters leave it empty. */
export const EmptyCardMessage = ({
  reason,
  onClear,
  className,
}: EmptyCardMessageProps) => {
  const classes = `${styles.message} ${className ?? ''}`

  if (reason === 'no-rows') {
    return <p className={classes}>No data for the selected filters.</p>
  }

  return (
    <div className={classes}>
      <p className={styles.title}>Market filtering not available</p>
      <p className={styles.text}>
        This module only displays global data. Clear the market filters to view
        this section.
      </p>
      <button type='button' className={styles.clear} onClick={onClear}>
        Clear filters
        <ClearCircleIcon />
      </button>
    </div>
  )
}
